<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/13UGJ5w/tc-custom/9781504057561.jpg?1699140298610" alt="This image is the cover for the book Kent Family Chronicles Volumes Four Through Six, The Kent Family Chronicles"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Kent Family Chronicles Volumes Four Through Six, The Kent Family Chronicles
      </h1>
      <p class="bookDescription body article font2">
        <b>A family builds its empire in books four through six of an American historical epic from the #1 <i>New York Times</i>–bestselling author of <i>North and South</i>.</b><br/>  <br/> This multigenerational saga follows the Kent family in their pursuit of a better future in the expanding United States amid deceit, passion, and violence. From the brutal Battle of the Alamo to the bloody Civil War, their fate is intertwined with the course of American history in these three volumes of the series.<br/>  <br/><i>The Furies</i>: Spanning from 1836 to 1852, the fourth Kent Family novel opens with Amanda Kent just escaping the massacre at the Alamo. Brazen and focused, she works to make a new life for herself during the California Gold Rush, and she’s willing to risk everything to restore her family’s name . . .<br/>  <br/><i>The Titans</i>: In the hellish years of the Civil War, while the nation struggles with its identity, the Kent family fights greed and hatred. In New York, devious Louis Kent controls the family dynasty—now on the verge of collapse. Meanwhile, his cousin Jephtha Kent backs the abolitionist cause even though it may cost him his sons . . .<br/>  <br/><i>The Warriors</i>: With the advent of the transcontinental railroad, the Kents continue to fight for their place among America’s wealthy. Temptation beckons young Jeremiah Kent as a Southern belle lures him into a trap of lust, lies, and murder. The nation may be facing a rebirth, but that doesn’t mean all survive . . .
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Jakes
      </h2>
      
      <p class="authorDescription body article">John Jakes (b. 1932), the author of more than a dozen novels, is regarded as one of today&rsquo;s most distinguished writers of historical fiction. His work includes the highly acclaimed Kent Family Chronicles series and the North and South Trilogy. Jakes&rsquo;s commitment to historical accuracy and evocative storytelling earned him the title of &ldquo;the godfather of historical novelists&rdquo; from the <I>Los Angeles Times</I> and led to a streak of sixteen consecutive <I>New York Times</I> bestsellers. Jakes has received several awards for his work and is a member of the Authors Guild and the PEN American Center. He and his wife, Rachel, live on the west coast of Florida.&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4161a6af